<!-- 由 suu 创建于 2025-07-10 Thursday -->
<!-- 等级晋升提醒弹窗 -->
<template>
  <div class="MemberGradePop">
    <van-overlay :show="true" z-index="100" class-name="mgp-cent">
      <!-- 焕新升级 -->
      <div class="mgp-js">
        <img class="js-img" :src="popBg" alt="" />
        <div class="js-name">
          {{ $store.state.user.user.truename }}
        </div>
        <div class="js-btn" @click="handleClick"></div>
      </div>
      <!-- 晋升 -->
      <!-- 关闭 -->
      <van-icon class="s-close user-btn" @click="handleClose" name="close" />
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'MemberGradePop',

  components: {},

  props: {
    popInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {}
  },

  computed: {
    popBg() {
      return `https://cdnvue.gymcity.com.cn/uploads/mgs-pop-js-v${
        this.popInfo.grade
      }${this.popInfo.is_package ? '-gift' : ''}?v=2`
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handleClose() {
      this.$emit('on-close')
    },
    handleClick() {
      this.handleClose()
      this.$http._toVueH5Url(
        `member-grade?initIndex=${this.popInfo.grade - 1}`,
        'push',
        '会员等级'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.MemberGradePop {
  display: flex;
  flex-direction: column;
  align-items: center;
  .mgp-cent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .mgp-js {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: vw(-100);
      .js-img {
        width: vw(375);
        min-height: vw(300);
      }
      .js-name {
        font-size: vw(12);
        color: rgba(255, 255, 255, 0.8);
        position: absolute;
        left: vw(75);
        top: vw(142);
      }
      .js-btn {
        width: vw(230);
        height: vw(64);
        // background-color: #f00;
        position: absolute;
        bottom: vw(48);
      }
    }
    .s-close {
      font-size: vw(24);
      color: #fff;
      margin-top: vw(25);
    }
  }
}
</style>
